
        Component.define('share-modal', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el          = $(el);
const $form        = $el.find('form');

const $modalEnvie  = $el.find('.modal-envie');
const $URIAeronave = $el.find('[name="URIAeronave"]');
const $closeModal  = $el.find('[data-close-modal]');

const $wrapEnvie   = $el.find('.step.form-envie');

const $successMsg  = $el.find('.step.success');

const $errorMsg    = $el.find('.step.error');
const $formBack    = $el.find('[data-form-back]');

const $btnSend     = $el.find('[data-send]');

$el.on('modal:open', function(event, URI) {
    $modalEnvie.addClass('active');
    $URIAeronave.val(URI);
    $btnSend.html('Enviar sugestão').removeClass('sending').removeAttr('disabled');
}).on('modal:close', function() {
    $modalEnvie.removeClass('active');
    $URIAeronave.val('');
    $form[0].reset();
    $('.step').removeClass('active');
    $wrapEnvie.addClass('active');
});

$closeModal.on('click', function() {
    $el.trigger('modal:close');
});

$formBack.on('click', function() {
    $('.step').removeClass('active');
    $wrapEnvie.addClass('active');
});

$form.on('submit', function(e) {
    e.preventDefault();

    $btnSend.html('Enviando...').addClass('sending').attr('disabled', true);;

    const $this = $(this);
    const dataForm = $this.serialize();

    $.post(root + 'share', dataForm).done(function( data ) {
        $('.step').removeClass('active');
        $btnSend.html('Enviar sugestão').removeClass('sending').removeAttr('disabled');

        if (data == 'success') {
            $successMsg.addClass('active');
        } else {
            $errorMsg.find('h1').html(data);
            $errorMsg.addClass('active');
        }
    });
});

        });